export class SplunkLogStatement {
    private RetailerNumber?: string;
    private RetailerName?: string;
    private RetailerType?: string;
    
    private UserId?: number;
    private UserName?: string;
    private UserType?: string;

    private SplunkReportEvent?: string;
    private EventDateTime?: Date;

    private QuoteId?: number;
    private ModelId?: number;
    private ModelDescription?: string;
    private FacilityId?: number;

    public SetRetailer(retailerNumber: string, retailerName: string, retailerType: string)
    {
        this.RetailerNumber = retailerNumber;
        this.RetailerName = retailerName;
        switch (retailerType)
        {
            case "I":
                this.RetailerType = "Independent";
                break;
            case "C":
                this.RetailerType = "Clayton";
                break;
            case "P":
                this.RetailerType = "Park";
                break;
            default:
                this.RetailerType = "Unknown";
        }
    }

    public SetRetailerForResult(retailerNumber: string, retailerName: string, retailerType: string)
    {
        this.RetailerNumber = retailerNumber;
        this.RetailerName = retailerName;
        this.RetailerType = retailerType;
    }

    public SetUser(userId: number, userName: string, userType: string)
    {
        this.UserId = userId;
        this.UserName = userName;
        this.UserType = userType;        
    }  

    public SetEvent(splunkReportEvent: SplunkLogEventType)
    {
        this.SplunkReportEvent = SplunkLogEventType[splunkReportEvent];
        this.EventDateTime = new Date();
    }

    public SetEventForResult(splunkReportEvent: string, eventDateTime: Date)
    {
        this.SplunkReportEvent = splunkReportEvent;
        this.EventDateTime = eventDateTime;
    }

    public SetQuote(quoteId: number, modelId: number, modelDescription: string, facilityId: number)
    {
        this.QuoteId = quoteId;
        this.ModelId = modelId;
        if (modelDescription != null) {
            this.ModelDescription = modelDescription.trim();
        }
        this.FacilityId = facilityId;
    }
}

export enum SplunkLogEventType {
    TRUExpress = 1,
    QuoteSaveAndNext = 2
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/splunk-log-statement.ts